import {
  Component,
  ChangeDetectionStrategy,
  HostBinding,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { MenuItem } from '../../interfaces/menu-item.interface';

@Component({
  selector: 'app-submenu-items',
  templateUrl: './submenu-items.component.html',
  styleUrls: ['./submenu-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubmenuItemsComponent {
  @HostBinding('class.main-menu__submenu')
  public submenuClass = true;

  @Input()
  public submenus: MenuItem[];

  @Output()
  public linkClicked = new EventEmitter<MenuItem>();

  public onClick(link: MenuItem): void {
    this.linkClicked.emit(link);
  }
}
